import React, { useEffect, useState, useMemo } from "react";
import {
  formatCurrency,
  getAlert,
  parseCurrency,
} from "../../../utils/SamuiUtils";
import Datetime from "react-datetime";
import moment from "moment";

const PAYMENT_METHODS = {
  cash: "เงินสด",
  transfer: "โอนเงิน",
  cheque: "เช็ค",
  credit: "เครดิต",
  unpaid: "ค้างชำระ",
};

const PaymentModal = ({
  mode,
  show,
  grandTotal,
  paymentType,
  setPaymentType,
  paymentAmount,
  setPaymentAmount,
  handlePayTypeClose,
  handleUpdatePayment,
  handleUploadSlip,
  base64Image,
  setBase64Image,
  chequeNo,
  setChequeNo,
  chequeName,
  setChequeName,
  chequeBranch,
  setChequeBranch,
  showConfirmModal,
  setShowConfirmModal,
  checkPayment,
  isAllowCredit,
}) => {
  console.debug("paymentAmount22", paymentAmount);
  // const [showConfirmModal, setShowConfirmModal] = React.useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const totalPaid = useMemo(() => {
    return Object.values(paymentAmount).reduce(
      (acc, val) => acc + parseCurrency(val || 0),
      0
    );
  }, [paymentAmount]);

  const setuppaymentType = () => {
    if (window.location.pathname !== "/invoice") {
      setPaymentType({
        cash: false,
        transfer: false,
        cheque: false,
        credit: false,
        unpaid: false,
      });
      
      setPaymentAmount({
        cash: "0.00",
        transfer: "0.00",
        cheque: "0.00",
        credit: "0.00",
        unpaid: "0.00",
      });
    } else {
      setPaymentType(paymentType);
      console.debug("paymentAmount", paymentAmount);
      setPaymentAmount(paymentAmount);
    }
  };

  useEffect(() => {
    if (mode === "I" && show) {
      // เคลียค่าทั้งหมด
      setuppaymentType();
      setChequeNo("");
      setChequeName("");
      setChequeBranch("");
      setBase64Image("");
    }
  }, [mode, show]);

  const togglePaymentMethod = (method) => {
    setPaymentType((prev) => {
      const newSelected = { ...prev, [method]: !prev[method] };
  
      const selectedMethods = Object.keys(newSelected).filter(
        (key) => newSelected[key]
      );
  
      // อัปเดตยอดหลังจาก state paymentType ใหม่ถูกใช้แล้ว
      setTimeout(() => {
        if (newSelected[method]) {
          // ถ้าเป็นตัวแรกที่เลือก → ใส่ grandTotal ให้
          if (selectedMethods.length === 1) {
            setPaymentAmount((prevPayments) => ({
              ...prevPayments,
              [method]: formatCurrency(grandTotal),
            }));
          }
        } else {
          // ถ้าเอาออก → เคลียร์ค่า
          setPaymentAmount((prevPayments) => ({
            ...prevPayments,
            [method]: "0.00",
          }));
  
          // ถ้ามีตัวอื่นที่เหลือ → ใส่ grandTotal ให้ตัวถัดไป
          const firstMethod = selectedMethods.find((key) => key !== method);
          if (firstMethod) {
            setPaymentAmount((prevPayments) => ({
              ...prevPayments,
              [firstMethod]: formatCurrency(grandTotal),
            }));
          }
        }
  
        // reset ข้อมูลเช็ค
        if (method === "cheque" && !newSelected[method]) {
          setChequeNo("");
          setChequeName("");
          setChequeBranch("");
        }
      }, 0); // รอให้ state ใหม่ apply ก่อน
  
      return newSelected;
    });
  
    // ไม่ต้องเรียก handleBlur ตรงนี้
  };
  

  const handleChange = (method, value) => {
    setPaymentAmount((prev) => ({
      ...prev,
      [method]: value,
    }));
  };

  const handleFocus = (field, value) => {
    const rawValue = parseCurrency(value);
    setPaymentAmount((prev) => ({ ...prev, [field]: rawValue }));
  };

  const handleBlur = (field, value) => {
    const formattedValue = formatCurrency(parseCurrency(value));
    setPaymentAmount((prev) => ({ ...prev, [field]: formattedValue }));
  };

  const handleConfirmPayment = () => {
    const hasSelectedPaymentMethod = Object.values(paymentType).some(
      (isSelected) => isSelected
    );

    if (!hasSelectedPaymentMethod) {
      getAlert("FAILED", "กรุณาเลือกช่องทางการชำระเงิน");
      setShowConfirmModal(false);
      return;
    }

    if (parseCurrency(totalPaid) === 0) {
      getAlert("FAILED", "กรุณาระบุยอดชำระเงิน");
      setShowConfirmModal(false);
      return;
    }

    setShowConfirmModal(false);
    handleUpdatePayment();
  };

  const GROUP_A = ["cash", "transfer", "cheque"];
  const GROUP_B = ["credit"];
  const GROUP_C = ["unpaid"];

  const isGroupASelected =
    paymentType && GROUP_A.some((method) => paymentType[method]);
  const isGroupBSelected =
    paymentType && GROUP_B.some((method) => paymentType[method]);
  const isGroupCSelected =
    paymentType && GROUP_C.some((method) => paymentType[method]);

  if (!show) return null;

  const handleChangeDateMaster = (value, name) => {
    // ตรวจสอบว่า value เป็น moment object หรือไม่
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;
    // อัปเดตค่าใน formMasterList
    setChequeBranch(newValue);
    setIsCalendarOpen(false);
  };

  return (
    <div
      className="modal"
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1050,
      }}
    >
      <div className="modal-dialog modal-md" role="document">
        <div
          className="modal-content shadow-lg"
          style={{
            borderRadius: "15px",
            overflow: "hidden",
            minHeight: isCalendarOpen ? "900px" : "550px",
          }}
        >
          <div
            className="modal-header"
            style={{
              backgroundColor: "#EF6C00",
              borderBottom: "none",
              padding: "20px",
            }}
          >
            <h5 className="modal-title fw-bold text-white">ชำระเงิน</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={handlePayTypeClose}
              aria-label="Close"
            ></button>
          </div>
          <div
            className="modal-body"
            style={{ padding: "30px 20px", overflowY: "auto" }}
          >
            <div
              class="p-3 text-center rounded"
              style={{ backgroundColor: "#FFEFCC" }}
            >
              <h4 class="fw-bold mt-2">
                ยอดชำระ: {formatCurrency(grandTotal)} บาท
              </h4>
              <div className="mt-4 w-100 text-center mx-auto">
                {Object.keys(PAYMENT_METHODS)
                  .filter(
                    (method) =>
                     (!["/bill", "/receipt"].includes(window.location.pathname) ||
  ["cash", "transfer", "cheque"].includes(method))
 &&
                      !(
                        window.location.pathname === "/invoice" &&
                        mode === "U" &&
                        !isAllowCredit &&
                        method === "credit"
                      )
                  )
                  .map((method) => {
                    const isDisabled =
                      (GROUP_A.includes(method) &&
                        (isGroupBSelected || isGroupCSelected)) ||
                      (GROUP_B.includes(method) &&
                        (isGroupASelected || isGroupCSelected)) ||
                      (GROUP_C.includes(method) &&
                        (isGroupASelected || isGroupBSelected));

                    const notApproveForInput =
                      (GROUP_B.includes(method) && isGroupBSelected) ||
                      (GROUP_C.includes(method) && isGroupCSelected);

                    return (
                      <div
                        className="d-flex align-items-center justify-content-between my-2"
                        key={method}
                      >
                        <button
                          className={`btn flex-grow-1`}
                          onClick={() => togglePaymentMethod(method)}
                          disabled={isDisabled}
                          style={{
                            minWidth: "80px",
                            borderRadius: "6px",
                            transition: "0.3s",
                            backgroundColor: paymentType[method]
                              ? "#EF6C00"
                              : "white",
                            color: paymentType[method] ? "white" : "black",
                            fontWeight: paymentType[method] ? "bold" : "normal",
                            cursor: isDisabled ? "not-allowed" : "pointer",
                            opacity: isDisabled ? 0.5 : 1,
                          }}
                        >
                          {PAYMENT_METHODS[method]}
                        </button>
                        <input
                          type="text"
                          className="form-control w-50 text-end ms-3"
                          value={paymentAmount[method]}
                          onChange={(e) => handleChange(method, e.target.value)}
                          onFocus={(e) => handleFocus(method, e.target.value)}
                          onBlur={(e) => handleBlur(method, e.target.value)}
                          disabled={
                            !paymentType[method] ||
                            isDisabled ||
                            notApproveForInput
                          }
                          style={{
                            borderRadius: "6px",
                            boxShadow: "inset 0 0 5px rgba(0,0,0,0.1)",
                            backgroundColor: paymentType[method]
                              ? "white"
                              : "#f0f0f0",
                            opacity:
                              !paymentType[method] ||
                              isDisabled ||
                              notApproveForInput
                                ? 0.5
                                : 1,
                          }}
                        />
                        <span className="ms-2">บาท</span>
                      </div>
                    );
                  })}
              </div>
              <h6 class="fw-bold mt-4 text-center">
                ยอดจ่าย:{" "}
                <span
                  style={{ color: totalPaid >= grandTotal ? "green" : "red" }}
                >
                  {formatCurrency(totalPaid)}
                </span>{" "}
                บาท
              </h6>
            </div>

            {/* สำหรับโอน */}
            {paymentType.transfer && (
              <div className="mt-3 text-center">
                <input
                  type="file"
                  id="fileInput"
                  style={{ display: "none" }}
                  onChange={handleUploadSlip}
                  accept=".png, .jpg, .jpeg, .gif, .svg"
                />
                <button
                  className="btn"
                  onClick={() => document.getElementById("fileInput").click()}
                  style={{
                    borderRadius: "5px",
                    backgroundColor: "#EF6C00",
                    color: "#fff",
                    padding: "8px 16px", // ขนาดปุ่มเล็กลง
                    fontSize: "14px",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                    transition: "background-color 0.3s",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#d85d00")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "#EF6C00")
                  }
                >
                  อัพโหลดสลิป
                </button>
                {base64Image && (
                  <div className="mt-3">
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#333",
                      }}
                    >
                      รูปภาพสลิป:
                    </p>
                    <img
                      src={base64Image}
                      alt="อัพโหลดสลิป"
                      style={{
                        maxWidth: "20%",
                        border: "1px solid #ddd",
                        borderRadius: "5px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      }}
                    />
                  </div>
                )}
              </div>
            )}

            {/* สำหรับเช็ค */}
            {paymentType.cheque && (
              <div
                class="p-3 rounded mt-4"
                style={{ backgroundColor: "#DCDCDC" }}
              >
                <h6 class="fw-bold mb-3">รายละเอียดเช็ค</h6>
                <div class="row g-3">
                  <div class="col-12">
                    <label class="form-label fw-bold">เลขที่เช็ค</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="กรอกเลขที่เช็ค"
                      value={chequeNo}
                      onChange={(e) => setChequeNo(e.target.value)}
                    />
                  </div>
                  <div class="col-12">
                    <label class="form-label fw-bold">ชื่อธนาคาร/สาขา</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="กรอกชื่อธนาคาร/สาขา"
                      value={chequeName}
                      onChange={(e) => setChequeName(e.target.value)}
                    />
                  </div>
                  <div class="col-12">
                    <label class="form-label fw-bold">ลงวันที่</label>
                    <Datetime
                      className="input-spacing-input-date"
                      name="whDocDate"
                      value={chequeBranch}
                      onChange={(date) => {
                        handleChangeDateMaster(date, "docDate");
                        setTimeout(() => setIsCalendarOpen(false), 100);
                      }}
                      dateFormat="DD-MM-YYYY"
                      timeFormat={false}
                      inputProps={{
                        readOnly: true,
                        onFocus: () => setIsCalendarOpen(true),
                        placeholder: "กรอกวันที่เช็ค",
                      }}
                      closeOnSelect={true}
                      style={{
                        maxHeight: "250px",
                        overflowY: "auto",
                        zIndex: 9999,
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer" style={{ borderTop: "none" }}>
            <button
              type="button"
              className="btn btn-outline-secondary me-2"
              onClick={handlePayTypeClose}
              style={{ borderRadius: "5px" }}
            >
              ยกเลิก
            </button>
            <button
              type="button"
              className="btn"
              // onClick={() =>
              //   window.location.pathname === "/bill"
              //     ? checkPayment()
              //     : setShowConfirmModal(true)
              // }

              onClick={() => checkPayment()}
              style={{
                borderRadius: "5px",
                backgroundColor: "#EF6C00",
                color: "#fff",
              }}
            >
              บันทึกรายการชำระเงิน
            </button>
          </div>

          {showConfirmModal && (
            <div
              className="modal fade show"
              tabIndex="-1"
              style={{
                display: "block",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div
                    className="modal-header"
                    style={{ backgroundColor: "#FFE0B2", color: "#EF6C00" }}
                  >
                    <h5 className="modal-title fw-bold">ยืนยันการชำระเงิน</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowConfirmModal(false)}
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p className="text-center">
                      คุณแน่ใจว่าต้องการบันทึกรายการชำระเงินหรือไม่?
                    </p>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <button
                      type="button"
                      className="btn"
                      onClick={handleConfirmPayment}
                      style={{
                        width: "120px",
                        backgroundColor: "#EF6C00",
                        color: "#fff",
                      }}
                    >
                      ยืนยัน
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger mx-2"
                      onClick={() => setShowConfirmModal(false)}
                      style={{ width: "120px" }}
                    >
                      ยกเลิก
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
